import * as React from 'react';
import { PluginContext } from './PluginContext';
import { mergePlugins } from './mergePlugins';
import { jsx as _jsx } from "react/jsx-runtime";
function PluginProvider(props) {
  const children = props.children,
    plugins = props.plugins;
  const formattedSeries = React.useMemo(() => ({
    isInitialized: true,
    data: mergePlugins(plugins)
  }), [plugins]);
  return /*#__PURE__*/_jsx(PluginContext.Provider, {
    value: formattedSeries,
    children: children
  });
}
export { PluginProvider };